import { useState } from "react";
import ReactJson from "react-json-view";
import Modal from "../modal/Modal";
import Kanban from "./Kanban";
import CreateTicket from "./CreateTicket";
import Backlog from "./Backlog";



const Tickets = () => {
    const [activeSwtich, setActiveSwitch] = useState('backlog'); //kanban backlog
    //TODO persist in db

    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Modal isOpen={isModalOpen} onClose={() => { setIsModalOpen(false); }}>
                <CreateTicket />
            </Modal>

            <div className="container scrollable">
                <p className='title'>Tickets</p>
                <p className="sub-title">Project management</p>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '1rem 0rem' }}>
                    <div className="switch" >
                        <p className={`option ${activeSwtich === "backlog" ? "active" : ""}`} onClick={() => setActiveSwitch("backlog")}>
                            Backlog
                        </p>
                        <p className={`option ${activeSwtich === "kanban" ? "active" : ""}`}
                            onClick={() => setActiveSwitch("kanban")}>
                            Kanban
                        </p>
                    </div>

                    <div>

                        {activeSwtich === "backlog" && <button
                            className="btn add-btn"
                            style={{ padding: '.6rem 1rem' }}
                            onClick={() => setIsModalOpen(true)}
                        >Create Ticket</button>}

                    </div>

                </div>

                {activeSwtich === 'kanban' ? <Kanban /> : <Backlog />}

                {/* <ReactJson
                style={{}}
                src={{ tasks, dropover, isDragging, selectedItem }}
                name={false}
                collapsed={2}

                collapseStringsAfterLength={150}
                displayDataTypes={false}
                displayObjectSize={false}
                sortKeys={false}
            /> */}
            </div >
        </>

    )
}

export default Tickets